 import React, { useEffect, useRef, useState } from 'react';
  import * as THREE from 'three';
  import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
  import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
  
  import { DataGrid } from '@mui/x-data-grid';
  import { Button, FormControlLabel, InputLabel, MenuItem, Select, Switch, Typography } from '@mui/material';
  import { GridColDef } from '@mui/x-data-grid';
  import { SelectChangeEvent } from '@mui/material/Select';
  import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment';
  import { Modal} from '@mui/material';
  
  import Chart from 'react-apexcharts';
  //import '../../css/d3.css';
  import axios from 'axios';
  

  
  

  type Helicoide = {
    idHelicoide: number;
    local: string;
    linha: number;
    coluna: number;
    valor: number;
    rosca: any; // ou `null`, se preferir
  };


  interface Tabela {
    idTabela: number;
    data: string;
    corrosao: string;
    abaulamento: string;
    trinca: string;
    poros: string;
  }





  export default function ThreeDScene() {

  const [parteSelecionada, setParteSelecionada] = useState<{ parte: string, infoEspe: string } | null>(null);
  const [imagemSelecionada, setImagemSelecionada] = useState<string | null>(null);
  const [imagens, setImagens] = useState<string[]>([]);


  const itens = [
      { cor: 'red', texto: 'Trinca' },
      { cor: 'brown', texto: 'Corrosão' },
      { cor: 'yellow', texto: 'Poros' },
      { cor: 'blue', texto: 'Abaulamento' },
    ];




    const mountRef = useRef<HTMLDivElement>(null);
    const [glbModel, setGlbModel] = useState<THREE.Object3D | null>(null);

  const [tooltip, setTooltip] = useState<{ x: number; y: number; text: string } | null>(null);
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();
    const [helicoide, setHelicoide]  = React.useState('');
  const originalColors = useRef<Map<string, THREE.Color>>(new Map());
  // Gera cor com base no valor
  const getColor = (val: number) => {
    if (val > 8 && val <= 15) return '#06D6A0'; // verde
    if (val > 4 && val <= 8) return '#FFD166'; // amarelo
    if (val > 0 && val <= 4) return '#EF476F'; // vermelho
    return '#CCCCCC'; // cor padrão para valores <= 0, opcional
  };

  const [partesComTextura, setPartesComTextura] = useState<
    { parte: string; textura: string, infoEspe: string }[]
  >([]);

  const sceneRef = useRef<THREE.Scene | null>(null);
  const [coluna0, setColuna0] = useState<number[]>([]);
  const [coluna1, setColuna1] = useState<number[]>([]);
  const [coluna2, setColuna2] = useState<number[]>([]);
  const [coluna3, setColuna3] = useState<number[]>([]);


    const [tableData, setTableData] = useState<Tabela[]>([
       
    ]);
 const [selectedId, setSelectedId] = useState<number | null>(null);


  let zero: number[] = [0, 0, 0];
  let noventa: number[] = [0, 0, 0];
  let centooitenta: number[] = [0, 0, 0];
  let duzentossetenta: number[] = [0, 0, 0];



  const rawValues = [3, 1.5, 1  ]; // Valores reais
  const maxValue = 15;
  // Valores convertidos para porcentagem
  
  const series0 = coluna0.map(val => (val / maxValue) * 100);
  const colors0 = coluna0.map(val => getColor(val));
  const series90 = coluna1.map(val => (val / maxValue) * 100);
  const colors90 = coluna1.map(val => getColor(val));
  const series180 = coluna2.map(val => (val / maxValue) * 100);
  const colors180 = coluna2.map(val => getColor(val));
  const series270 = coluna3.map(val => (val / maxValue) * 100);
  const colors270 = coluna3.map(val => getColor(val));



  
  //const series = coluna0.map(val => (val / maxValue) * 100);
  //const colors = coluna0.map(getColor);
  const valores = [
    ['1.2', '3.4', '0.0', '2.1'],
    ['2.0', '0.0', '1.5', '0.9'],
    ['0.5', '0.5', '0.5', '0.5']
  
  ];

  const data = [
    {
      angulo: '0°',
      linha1: parseFloat(valores[0][0]),
      linha2: parseFloat(valores[1][0]),
      linha3: parseFloat(valores[2][0]),
    
    },
    {
      angulo: '90°',
      linha1: parseFloat(valores[0][1]),
      linha2: parseFloat(valores[1][1]),
      linha3: parseFloat(valores[2][1]),
      
    },
    {
      angulo: '180°',
      linha1: parseFloat(valores[0][2]),
      linha2: parseFloat(valores[1][2]),
      linha3: parseFloat(valores[2][2]),
    
    },
    {
      angulo: '270°',
      linha1: parseFloat(valores[0][3]),
      linha2: parseFloat(valores[1][3]),
      linha3: parseFloat(valores[2][3]),
      
    },
  ];






  const handleChangeCombo = async (event: SelectChangeEvent) => {
    const nomehelicoide =  event.target.value;
  
    setHelicoide(event.target.value)
  // console.log(nomeHelicoide);
      const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/rosca/helicoide/${selectedId}`,
  { withCredentials: true }
);


      const dados: Helicoide[] = response.data;

    //  console.log(dados);
      try {


      // 🔎 Filtra os dados pelo nome da helicoide
      const filtrados = dados.filter(item => item.local === nomehelicoide);

      // 🧱 Monta a matriz 3x4
      const matriz: (number | null)[][] = Array.from({ length: 3 }, () => Array(4).fill(null));

      filtrados.forEach(item => {
        matriz[item.linha][item.coluna] = item.valor;
      });

      // 🔄 Extrai colunas
      const colunas = [0, 1, 2, 3].map(colIdx =>
        matriz.map(linha => linha[colIdx])
      );

      console.log(`Valores da ${nomehelicoide}:`);
      console.log('Coluna 0:', colunas[0]);
      console.log('Coluna 1:', colunas[1]);
      console.log('Coluna 2:', colunas[2]);
      console.log('Coluna 3:', colunas[3]);

      setColuna0(colunas[0].filter((v): v is number => v !== null));
      setColuna1(colunas[1].filter((v): v is number => v !== null));
      setColuna2(colunas[2].filter((v): v is number => v !== null));
      setColuna3(colunas[3].filter((v): v is number => v !== null));
    


      // Atualiza os estados se quiser usar na tela
      
    } catch (error) {
      console.error('Erro ao buscar helicoides:', error);
    }
  };


const handleOpenRelatorio = async () => {
  try {
    const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/rosca/urlrelatorio/${selectedId}`,
  { withCredentials: true }
);

    const url = response.data;

    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Relatório não encontrado.');
    }
  } catch (error) {
    console.error('Erro ao buscar relatório:', error);
    alert('Erro ao buscar o relatório.');
  }
};



const handleOpenRelatorioNR13 = async () => {
  try {
    const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/rosca/urlrelatorionr13/${selectedId}`,
  { withCredentials: true }
);

    const url = response.data;

    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Relatório não encontrado.');
    }
  } catch (error) {
    console.error('Erro ao buscar relatório:', error);
    alert('Erro ao buscar o relatório.');
  }
};




  const handleTabelaDadosRelatorio = (ids: number) => {
      console.log('Ação 1 clicada para o ID:', ids);
      setSelectedId(ids);
  
      aplicarTexturas(ids)
  

      //Ativar bota + informa~c"oes
  
  
    };
    const [state, setState] = React.useState({
      abaulamento: false,
      trinca: false,
      poros: false,
      corrosao: false
    });

    const columnsDadosPG: GridColDef<Tabela>[] = [
      {
        field: 'idTabela',
        headerName: 'ID',
        width: 40,
        headerAlign: 'center',
        align: 'center',
        type: 'number'
      },
      {
        field: 'data',
        headerName: 'Data',
        width: 100,
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        valueFormatter: (params) => {
          const date = new Date(params.value);
          return date.toLocaleDateString('pt-BR'); // Formata para DD/MM/YYYY
        }
      },
      {
        field: 'abaulamento',
        headerName: 'Abaulamento',
        width: 120,
        headerAlign: 'center',
        align: 'center',
        type: 'string'
      },
      {
        field: 'corrosao',
        headerName: 'Corrosão',
        width: 120,
        headerAlign: 'center',
        align: 'center',
        type: 'string'
      },
      {
        field: 'trinca',
        headerName: 'Trinca',
      width: 120,
        headerAlign: 'center',
        align: 'center',
        type: 'string'
      },
      {
        field: 'poros',
        headerName: 'Poros',
        width: 120,
        headerAlign: 'center',
        align: 'center',
        type: 'string'
      },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 150,
        renderCell: (params: { id: any }) => (
          <strong>
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{ marginLeft: 16 }}
              onClick={() => handleTabelaDadosRelatorio(params.id)}
            >
              Selecionar
            </Button>
          </strong>
        ),
      },
    ];
    
    const options0: ApexCharts.ApexOptions = {
      chart: {
        type: 'radialBar',
        height: 400,
        background: 'WHITE',
        sparkline: { enabled: true }
      },
      plotOptions: {
        radialBar: {
          startAngle: -145,
          endAngle: 145,
          track: {
            strokeWidth: '30%',
            margin: 8,
            background: '#2b2f3a',
          },
          hollow: {
            size: '35%',
            background: '#1e1e2f',
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: '14px',
              color: '#ffffff',
              offsetY: -10
            },
            value: {
              show: true,
    fontSize: '16px',
    fontWeight: 700,
    color: '#ffffff',
    offsetY: 5,
              formatter: ((val: number, opts: any) => {
      const index = opts.seriesIndex;
      if (index === 2) return `${zero[2]}`;
      return `${val.toFixed(0)}%`;
    }) as unknown as (val: number) => string
            },
            total: {
              show: true,
              label: '0º', // ⬅️ Texto no centro
              fontSize: '22px',
              color: '#ffffff',
              formatter: () => ''
            }
          },
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: 'dark',
        y: {
      formatter: (_val: number, { seriesIndex }: any) =>
        `${coluna0[seriesIndex]}`
    }
      },
      labels: ['Medida 1', 'Medida 2', 'Medida 3'],
      fill: { opacity: 1 },
      colors: colors0,
      stroke: { lineCap: 'round' },
      theme: { mode: 'dark' }
    };
    


    const options90: ApexCharts.ApexOptions = {
      chart: {
        type: 'radialBar',
        height: 400,
        background: 'WHITE',
        sparkline: { enabled: true }
      },
      plotOptions: {
        radialBar: {
          startAngle: -145,
          endAngle: 145,
          track: {
            strokeWidth: '30%',
            margin: 8,
            background: '#2b2f3a',
          },
          hollow: {
            size: '35%',
            background: '#1e1e2f',
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: '14px',
              color: '#ffffff',
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '16px',
              fontWeight: 700,
              color: '#ffffff',
              offsetY: 5,
              formatter: (val: number) => `${val.toFixed(0)}%`
            },
            total: {
              show: true,
              label: '90º', // ⬅️ Texto no centro
              fontSize: '22px',
              color: '#ffffff',
              formatter: () => ''
            }
          },
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: 'dark',
        
        y: {
      formatter: (_val: number, { seriesIndex }: any) =>
        `${coluna1[seriesIndex]}`
    }
      },
      fill: { opacity: 1 },
        labels: ['Medida 1', 'Medida 2', 'Medida 3'],
      colors: colors90,
      stroke: { lineCap: 'round' },
      theme: { mode: 'dark' }
    };


    const options180: ApexCharts.ApexOptions = {
      chart: {
        type: 'radialBar',
        height: 400,
        background: 'WHITE',
        sparkline: { enabled: true }
      },
      plotOptions: {
        radialBar: {
          startAngle: -145,
          endAngle: 145,
          track: {
            strokeWidth: '30%',
            margin: 8,
            background: '#2b2f3a',
          },
          hollow: {
            size: '35%',
            background: '#1e1e2f',
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: '14px',
              color: '#ffffff',
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '16px',
              fontWeight: 700,
              color: '#ffffff',
              offsetY: 5,
              formatter: (val: number) => `${val.toFixed(0)}%`
            },
            total: {
              show: true,
              label: '180º', // ⬅️ Texto no centro
              fontSize: '22px',
              color: '#ffffff',
              formatter: () => ''
            }
          },
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: 'dark',
          y: {
      formatter: (_val: number, { seriesIndex }: any) =>
        `${coluna2[seriesIndex]}`
    }
      },
      fill: { opacity: 1 },
        labels: ['Medida 1', 'Medida 2', 'Medida 3'],
      colors: colors180,
      stroke: { lineCap: 'round' },
      theme: { mode: 'dark' }
    };


  const glbModelRef = useRef<THREE.Object3D | null>(null);



    const options270: ApexCharts.ApexOptions = {
      chart: {
        type: 'radialBar',
        height: 400,
        background: 'WHITE',
        sparkline: { enabled: true }
      },
      plotOptions: {
        radialBar: {
          startAngle: -145,
          endAngle: 145,
          track: {
            strokeWidth: '30%',
            margin: 8,
            background: '#2b2f3a',
          },
          hollow: {
            size: '35%',
            background: '#1e1e2f',
          },
          dataLabels: {
            name: {
              show: true,
              fontSize: '14px',
              color: '#ffffff',
              offsetY: -10
            },
            value: {
              show: true,
              fontSize: '16px',
              fontWeight: 700,
              color: '#ffffff',
              offsetY: 5,
              formatter: (val: number) => `${val.toFixed(0)}%`
            },
            total: {
              show: true,
              label: '270º', // ⬅️ Texto no centro
              fontSize: '22px',
              color: '#ffffff',
              formatter: () => ''
            }
          },
        },
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: 'dark',
        y: {
      formatter: (_val: number, { seriesIndex }: any) =>
        `${coluna3[seriesIndex]}`
    }
      },
      fill: { opacity: 1 },
        labels: ['Medida 1', 'Medida 2', 'Medida 3'],
      colors: colors270,
      stroke: { lineCap: 'round' },
      theme: { mode: 'dark' }
    };

  const scene = new THREE.Scene();

  //#fe0401 vermelho metãlico

  const envMapRef = useRef<THREE.Texture | null>(null);


    const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    //const seriesPercentual = series.map(val => (val / maxValue) * 100);

  const clickCountRef = useRef(0);
  const rendererRef = useRef<THREE.WebGLRenderer | null>(null);



  // Utility to show infoEspe in a modal or alert
  const handleShowInfo = (parte: string) => {
    const found = partesComTextura.find(p => p.parte === parte);
    const info = found?.infoEspe || 'Sem informação disponível.';
    alert(`ℹ️ ${parte}: ${info}`);
  };
    
  useEffect(() => {
    if (!mountRef.current) return;
  if (!rendererRef.current) {
      rendererRef.current = new THREE.WebGLRenderer({ antialias: true });
    }
    // Renderer
    renderer.setSize(1200, 700);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.domElement.style.background = '#bfe3dd';
    renderer.domElement.style.border = '1px solid #ccc';
    renderer.domElement.style.display = 'block';
    renderer.domElement.style.margin = 'auto';
    renderer.domElement.style.borderRadius = '15px';
    mountRef.current.appendChild(renderer.domElement);

    // Cena e câmera
    sceneRef.current = scene;
    camera.position.set(0, 0, 10);
    camera.lookAt(0, 0, 0);
    scene.background = new THREE.Color(0xbfe3dd);

    // Ambiente HDRI
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    const envMap = pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;
    scene.environment = envMap;
    envMapRef.current = envMap;

    // Luz ambiente
    const ambientLight = new THREE.AmbientLight(0xffffff, 1.2);
    scene.add(ambientLight);

    // OrbitControls
    const controls = new OrbitControls(camera, renderer.domElement);
    controls.target.set(0, 0.5, 0);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.update();

    // Carrega GLB
    const loader = new GLTFLoader();
    let model: THREE.Object3D;

    loader.load('/Rosca2.glb', (gltf) => {
   // loader.load('/teste3.glb', (gltf) => {
      model = gltf.scene;

      // Centraliza o modelo
      const box = new THREE.Box3().setFromObject(model);
      const center = box.getCenter(new THREE.Vector3());
      model.position.sub(center);
      model.scale.set(1, 1, 1);

      // Material padrão
   model.traverse((child) => {
  if (child instanceof THREE.Mesh) {
    child.geometry.computeVertexNormals();
    child.material = new THREE.MeshStandardMaterial({
      color: 0xaaaaaa,
      metalness: 1.0,
      roughness: 0.2,
      envMap: scene.environment,
      envMapIntensity: 1.5,
      side: THREE.DoubleSide // ✅ Corrige visualização de todos os lados
    });
    child.material.needsUpdate = true;
  }
});


      glbModelRef.current = model;
      setGlbModel(model); // <- ✅ Tipo Object3D
      scene.add(model);
    });

    // Animação
    let animationId: number;
    const animate = () => {
      animationId = requestAnimationFrame(animate);
      controls.update();
      renderer.render(scene, camera);
    };
    animate();

    // Buscar dados de roscas
   const response = axios.get(
  `${process.env.REACT_APP_API_URL}/rosca/listar`,
  { withCredentials: true }
)


      .then(response => {
        const dadosConvertidos = response.data.map((rosca: any) => ({
          idTabela: rosca.idRosca,
          data: rosca.dataInspecao,
          corrosao: rosca.corrosao,
          trinca: rosca.trinca,
          poros: rosca.poros,
          abaulamento: rosca.abaulamento
        }));
        setTableData(dadosConvertidos);
      })
      .catch(error => {
        console.error('Erro ao buscar roscas:', error);
      });

    

  

  return () => {
      // Cleanup
      if (rendererRef.current) {
        rendererRef.current.forceContextLoss(); // <- força liberação do contexto WebGL
        rendererRef.current.dispose();          // <- limpa recursos ligados à GPU
        rendererRef.current = null;
      }

      if (glbModelRef.current) {
        glbModelRef.current.traverse((child: any) => {
          if (child.isMesh) {
            child.geometry.dispose();
            if (Array.isArray(child.material)) {
              child.material.forEach((m: { dispose: () => any; }) => m.dispose());
            } else {
              child.material.dispose();
            }
          }
        });
      }

      scene.clear();
      console.log('🧼 Cleanup completo!');
    };
  }, []);





    
  //}, []);


    // ✅ Método separado para aplicar texturas
      const aplicarTexturas = async (idRosca: number) => {


    const cena = sceneRef.current;

  if (!cena) {
    console.warn('🛑 Cena ainda não foi carregada.');
    return;
  }
  cena.traverse((child: any) => {
    if (child.isMesh) {
      const material = new THREE.MeshStandardMaterial({
      color: 0xaaaaaa,
            metalness: 1.0,
            roughness: 0.2,
            envMap: scene.environment,
            envMapIntensity: 1.5,
            side: THREE.DoubleSide
      });
      child.material = material;
      child.material.needsUpdate = true;
    }
  });

    clickCountRef.current += 1;


    if (clickCountRef.current >= 3) {
      console.warn('🔄 Recarregando a página após 3 cliques com Ctrl...');
      clickCountRef.current = 0;
      window.location.reload();
      console.log(document.querySelectorAll("canvas").length);
    
      return;
    }

      

  try {
const response1 = await axios.get(
  `${process.env.REACT_APP_API_URL}/rosca/imagens/${idRosca}`,
  { withCredentials: true }
);


      const urls: string[] = response1.data; // supondo que o backend retorne lista de URLs
      setImagens(urls);
    } catch (error) {
      console.error("Erro ao carregar imagens da rosca:", error);
      setImagens([]);
    }




        try {
         const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/parte/buscaid/${idRosca}`,
  { withCredentials: true }
);


          const partes = response.data;
          setPartesComTextura(partes);

          
        





          cena.traverse((child: any) => {
            if (child.isMesh) {
              const nomeMalha = child.name;
        const parte = partes.find((p: any) => p.parte === nomeMalha);

        if (parte) {
          const texturaNome = parte.textura?.toLowerCase();

          console.log(`🔎 Aplicando para ${nomeMalha}: ${texturaNome}`);




                child.material.map = null;

                if (texturaNome === 'trinca') {
                  child.material.color.set(0xff0000); //VERMELHO
                } 
                if (texturaNome === 'corrosao') {
                  child.material.color.set(0xFF8C00);  //LARANJA  #FF8C00
                } 

                if (texturaNome === 'poros') {
                  child.material.color.set(0xffff00);  //AMARELO 
                } 


                if (texturaNome === 'abaulamentos') {
                  child.material.color.set(0x0000FF);  //AZUL 
                } 

                
                child.material.side = THREE.DoubleSide;
                child.material.needsUpdate = true;
              }
            }
          });
        } catch (error) {
          console.error('Erro ao aplicar texturas:', error);
        }




      };

    function changeTextures() {
      if (!glbModel) {
        console.log("Modelo ainda não carregado.");
        return;
      }

    




  /*
      glbModel.traverse((child) => {
        if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
          let texture: THREE.Texture | null = null;

          switch (child.name) {
            case 'Parte1':
              console.log('Alterando textura de Parte1');
              child.material.color.set(0xff0000);
            // texture = textureLoader.load('Trinca.png');
            // child.material.map = texture; //APLICAR TEXTURA CORES!!!
              child.material.side = THREE.DoubleSide;
              child.material.needsUpdate = true;
              break;
            case 'Parte2':
              console.log('Alterando textura de Parte2');
              texture = textureLoader.load('Corrosao.png');
              child.material.map = texture;
              child.material.side = THREE.DoubleSide;
              child.material.needsUpdate = true;
              break;
            case 'Parte3':
              console.log('Alterando textura de Parte3');
              texture = textureLoader.load('Trinca.png');
              child.material.map = texture;
              child.material.side = THREE.DoubleSide;
              child.material.needsUpdate = true;
              break;

              case 'Parte4':
                console.log('Alterando textura de Parte4');
                texture = textureLoader.load('Trinca.png');
                child.material.map = texture;
                child.material.side = THREE.DoubleSide;
                child.material.needsUpdate = true;
                break;

                case 'Parte34':
                  console.log('Alterando textura de Parte3');
                  texture = textureLoader.load('Trinca.png');
                  child.material.map = texture;
                  child.material.side = THREE.DoubleSide;
                  child.material.needsUpdate = true;
                  break;


          }

          if (texture) {
            child.material.map = texture;
            child.material.side = THREE.DoubleSide;
            child.material.needsUpdate = true;
          }
        }
      } );*/
    }
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setState({
        ...state,
        [event.target.name]: event.target.checked,
      });
    };










  const handleChangeTrinca = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
  resetarTexturas();
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: checked,
    }));

    if (checked) {
      try {
        const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/parte/buscatrincas`,
  { withCredentials: true }
);


        const partesTrinca = response.data;

  if (glbModel) {
    aplicarTexturasPorTipo(response.data, glbModel);
  }
  
      } catch (error) {
        console.error('Erro ao buscar partes com trinca:', error);
      }
    }  else {

    resetarTexturas();



    }
  };


  const handleChangePoros = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
  resetarTexturas();
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: checked,
    }));

    if (checked) {
      try {
        const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/parte/buscaporos`,
  { withCredentials: true }
);


        const partesTrinca = response.data;

  if (glbModel) {
    aplicarTexturasPorTipo(response.data, glbModel);
  }
  
      } catch (error) {
        console.error('Erro ao buscar partes com trinca:', error);
      }
    }  else {

    resetarTexturas();



    }
    
  };








  const handleChangeAbaulamento = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
  resetarTexturas();
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: checked,
    }));

    if (checked) {
      try {
        const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/parte/buscaabaulamentos`,
  { withCredentials: true }
);


        const partesTrinca = response.data;

  if (glbModel) {
    aplicarTexturasPorTipo(response.data, glbModel);
  }
  
      } catch (error) {
        console.error('Erro ao buscar partes com trinca:', error);
      }
    }  else {

    resetarTexturas();



    }
  };



  const handleChangeCorrosao = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
  resetarTexturas();
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: checked,
    }));

    if (checked) {
      try {
        const response = await axios.get(
  `${process.env.REACT_APP_API_URL}/parte/buscacorrosao`,
  { withCredentials: true }
);


        const partesTrinca = response.data;

  if (glbModel) {
    aplicarTexturasPorTipo(response.data, glbModel);
  }
  
      } catch (error) {
        console.error('Erro ao buscar partes com trinca:', error);
      }
    }  else {

    resetarTexturas();



    }
  };









  const aplicarTexturasPorTipo = (partes: any[], modelo: THREE.Object3D) => {
    modelo.traverse((child: any) => {
      if (child.isMesh) {
        const parte = partes.find((p: any) => p.parte === child.name);
        if (parte) {
          const texturaNome = parte.textura?.toLowerCase();
          console.log(`🔎 Aplicando para ${child.name}: ${texturaNome}`);

          child.material.map = null;

          if (texturaNome === 'trinca') {
            child.material.color.set(0xff0000); // Vermelho
          } else if (texturaNome === 'corrosao') {
            child.material.color.set(0xFF8C00); // Laranja
          } else if (texturaNome === 'poros') {
            child.material.color.set(0xffff00); // Amarelo
          } else if (texturaNome === 'abaulamentos') {
            child.material.color.set(0x0000FF); // Azul
          }
 
          child.material.side = THREE.DoubleSide;
          child.material.needsUpdate = true;
        }
      }
    });
  };
  


  const resetarTexturas = () => {

  clickCountRef.current += 1;

    
      
    if (clickCountRef.current >= 3) {
      console.warn('🔄 Recarregando a página após 3 cliques com Ctrl...');
      clickCountRef.current = 0;
      window.location.reload();
      console.log(document.querySelectorAll("canvas").length);
    
      return;
    }



  
    if (glbModelRef.current) {
      glbModelRef.current.traverse((child: any) => {
        if (child.isMesh) {
          // Remove textura e aplica cor padrão
          child.material.map = null;
          child.material.color.set(0xaaaaaa);
          child.material.side = THREE.DoubleSide;
          child.material.needsUpdate = true;
        }
      });

      
      console.log('🎨 Texturas e rotação resetadas.');
    } else {
      console.warn('⚠️ Modelo GLB ainda não carregado.');
    }

    
  };



    return (  
    
    
    
      <><br/><br/><br/><br/><div className="D3container">  
        <div className="poros">  <FormControlLabel
              control={<Switch checked={state.poros} onChange={handleChangePoros} name="poros" />}
              label="Todos Poros!!!!" />
              </div>
        <div className="trincas"> 

        <FormControlLabel
    control={
      <Switch
        checked={state.trinca}
        onChange={handleChangeTrinca}
        name="trinca"
      />
    }
    label="Todas Trincas"
  />



        </div>
        <div className="corrosao">   <FormControlLabel
              control={<Switch checked={state.corrosao} onChange={handleChangeCorrosao} name="corrosao" />}
              label="Todas Corrosões" />
              </div>
        <div className="abaulamento">  <FormControlLabel
              control={<Switch checked={state.abaulamento} onChange={handleChangeAbaulamento} name="abaulamento" />}
              label="Todos Abaulamentos" />
  </div>
        <div className="slideshow" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', padding: '10px' }}>
    {imagens.length === 0 ? (
      <Typography variant="body2" color="textSecondary">Nenhuma imagem disponível.</Typography>
    ) : (
      imagens.map((url, index) => (
        <img
          key={index}
          src={url}
          alt={`img-${index}`}
          onClick={() => window.open(url, '_blank')} // 🔍 abre em nova aba
          style={{
            width: '120px',
            height: '120px',
            objectFit: 'cover',
            borderRadius: '10px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            transition: 'transform 0.2s ease-in-out',
          }}
        />
      ))
    )}
  </div>


    <div className="table" >

 <Button
              variant="contained"
              color="primary"
              size="small"
               disabled={selectedId === null}
              style={{ marginLeft: 16 }}
             onClick={() => selectedId !== null && handleOpenRelatorioNR13()}
            >
              +Relatório
            </Button>


    <Button  variant="contained"
              color="primary"
              size="small"
               disabled={selectedId === null}
              style={{ marginLeft: 16 }}
              onClick={() => handleTabelaDadosRelatorio(1)}>            +Controle NR-13</Button>
  </div>

        <div className="D3g" ref={mountRef} style={{ width: '100%', height: '500px', position: 'relative' }}>




        </div>
        
      
      </div><div>
          <div >
            {/* 
            <button
              onClick={changeTextures}
              style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                padding: '10px',
                background: '#007bff',
                color: 'black',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                borderRadius: '5px'
              }}
            >
              Alterar Texturas
            </button>
*/}
            <br />


          <div style={{ width: '100%', maxWidth: '900px', margin: '0 auto' }}>
    <DataGrid
    rows={tableData}
    columns={columnsDadosPG}
    initialState={{
      pagination: {
        paginationModel: {
          pageSize: 5,
        },
      },
    }}
    pageSizeOptions={[5]}
    checkboxSelection
    disableRowSelectionOnClick
    getRowId={(row) => row.idTabela}
    sx={{
      '& .MuiDataGrid-cell': {
        padding: '4px 8px', // ⬅️ reduz espaçamento horizontal e vertical
      },
      '& .MuiDataGrid-columnHeader': {
        padding: '1px 8px', // ⬅️ idem para o cabeçalho
      },
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        gap: '0px !important', // ⬅️ elimina espaçamento entre colunas
      },
      columnSpacing: 4, // ⬅️ ajuste fino opcional
      rowHeight: 36,     // ⬅️ reduz altura das linhas
      headerHeight: 40,  // ⬅️ reduz altura do cabeçalho
    }}
  />

        </div>  
        

          </div>



        

          <br />
          <div   style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      
    }} >
          <InputLabel  id="demo-simple-select-helper-label">Escolha a helicóide:     </InputLabel> <br/><br/>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={helicoide}
            label="Age"
            onChange={handleChangeCombo}
            sx={{
              width: '300px',     // ⬅️ largura personalizada
              height: '56px',     // ⬅️ altura (opcional, padrão do MUI é 56px)
              fontSize: '16px'    // ⬅️ tamanho do texto
            }}
          >
            
            <MenuItem value={"Helicoide1"}>Helicoide 1</MenuItem>
            <MenuItem value={"Helicoide2"}>Helicoide 2</MenuItem>
            <MenuItem value={"Helicoide3"}>Helicoide 3</MenuItem>
            <MenuItem value={"Helicoide4"}>Helicoide 4</MenuItem>
            <MenuItem value={"Helicoide5"}>Helicoide 5</MenuItem>
            <MenuItem value={"Helicoide6"}>Helicoide 6</MenuItem>
          </Select>
          </div>
          <br /> <br />

          <div
                style={{
                  backgroundColor: '#F5F5F5',
                  padding: '24px',
                  borderRadius: '20px',
                  boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                  display: 'flex',
                  
                  justifyContent: 'center',
                }}
              >
          <Chart options={{ ...options0, colors: colors0 }} series={series0} type="radialBar" height={420} />

          <Chart options={{ ...options90, colors: colors90 }}series={series90} type="radialBar" height={420} />
          <Chart options={{ ...options180, colors: colors180 }} series={series180} type="radialBar" height={420} />
          <Chart options={{ ...options270, colors: colors270 }} series={series270} type="radialBar" height={420} />
              </div>
  
        </div>
        

  <Modal open={!!imagemSelecionada} onClose={() => setImagemSelecionada(null)}>
    <div
      onClick={() => setImagemSelecionada(null)}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1300,
        cursor: 'zoom-out',
      }}
    >
      <img
        src={imagemSelecionada || ''}
        alt="Imagem ampliada"
        style={{
          maxWidth: '90%',
          maxHeight: '90%',
          borderRadius: '8px',
          boxShadow: '0 0 20px rgba(0,0,0,0.5)',
        }}
      />
    </div>
  </Modal>

        
        </>
    );
  }
